import React, {memo} from 'react';
import DialogComponent from 'components/Dialog';
import {DialogTypes} from 'common/names';
import {ISFTPActivityReportParameters} from 'types/diplomat/reports/SFTPActivityReportParameters';

import {useDownloadPostApi} from 'common/hooks/useDownloadPostApi';
import api from 'api';
import {SFTPActivityReportForm} from './SFTPActivityReportForm';
import {FormOnSubmitHelpers} from 'components/hook-form/Formik';
import {enums} from 'types/enums';

type Props = {
   onClose: () => void;
};
export const SFTPActivityReportDialog = memo(({onClose}: Props) => {
   const {download} = useDownloadPostApi();
   const sendParameters = React.useCallback(
      (
         values: ISFTPActivityReportParameters,
         bag: FormOnSubmitHelpers<ISFTPActivityReportParameters>
      ) => {
         const url =
            values._format === enums.reportFormats.enum.CSV
               ? api.sftpActivityReport + 'csv'
               : api.sftpActivityReport;
         download(url, JSON.stringify(values), {
            onSuccess: () => bag.setSubmitting(false),
            onFailure: (errors: any) => {
               bag.setSubmitting(false);
               bag.setErrors(errors);
            },
         });
      },
      [download]
   );

   return (
      <DialogComponent
         maxWidth="lg"
         header={DialogTypes.SFTPActivityReportDialog.dialogName}
         close={onClose}
      >
         <SFTPActivityReportForm onClose={onClose} onSubmit={sendParameters} />
      </DialogComponent>
   );
});
